<form autocomplete="off" [formGroup]="formT3" (ngSubmit)="save()">
    <h4>Detalle de evento futuro:
        <ng-container *ngIf="t3"><small>{{t3.longtitle}}</small></ng-container>
    </h4>
    <hr>
    <div class="form-group row">
        <ng-container *ngIf="formT3.get('reviewedBy')?.value">
            <div class="textOnInput col-12 col-md-12">
                <label class="form-label">Revisor</label>
                <span class="form-control-plaintext text-muted text-start ms-3">
                    {{ formT3.get('reviewedBy').value }}
                </span>
            </div>
        </ng-container>
        <div class="textOnInput col-12 col-md-3">
            <label class="form-label">Código</label>
            <ng-container *ngIf="!edit; else editMode">
                <input class="form-control form-input lowercase" type="text" placeholder="Código" formControlName="code"
                    (blur)="validateCode()" [class.is-invalid]="campoNoValido('code')">
                <small class="text-danger" *ngIf="campoNoValido('code')">Este campo es requerido</small>
                <small class="text-info" *ngIf="codeValidationMessage">{{ codeValidationMessage }}</small>
            </ng-container>
            <ng-template #editMode>
                <span class="form-control-plaintext text-muted text-center">{{ formT3.get('code').value }}</span>
            </ng-template>
        </div>
        <div class="textOnInput col-12 col-md-12">
            <label class="form-label" for="inputText">Título corto</label>
            <input class="form-control form-input" type="text" formControlName="shorttitle" autocomplete="off"
                [class.is-invalid]="campoNoValido('shorttitle')">
            <small class="text-danger" *ngIf="campoNoValido('shorttitle')">Este campo es requerido</small>
        </div>
        <div class="textOnInput col-12">
            <label class="form-label">Título largo</label>
            <input class="form-control form-input" type="text" formControlName="longtitle" autocomplete="off"
                [class.is-invalid]="campoNoValido('longtitle')">
            <small class="text-danger" *ngIf="campoNoValido('longtitle')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-6 col-md-6 col-sm-12">
            <label class="form-label">Temática</label>
            <select class="form-select form-input" formControlName="idtematic"
                [class.is-invalid]="campoNoValido('idtematic')">
                <option selected disabled value="">Temática...</option>
                <option *ngFor="let tematic of tematics" value="{{tematic.id}}">
                    {{tematic.title}}
                </option>
            </select>
            <small class="text-danger" *ngIf="campoNoValido('idtematic')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-6 col-md-6">
            <label class="form-label">Versión</label>
            <input class="form-control form-input" type="text" formControlName="version" autocomplete="off"
                [class.is-invalid]="campoNoValido('version')">
            <small class="text-danger" *ngIf="campoNoValido('version')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-12">
            <label class="form-label">Sumilla</label>
            <textarea class="form-control" formControlName="summary" autocomplete="off"
                [class.is-invalid]="campoNoValido('summary')" rows="4"></textarea>
            <small class="text-danger" *ngIf="campoNoValido('summary')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-12">
            <label class="form-label">Descripción</label>
            <textarea class="form-control" formControlName="detail" autocomplete="off" rows="4"></textarea>
        </div>

        <div class="textOnInput col-6 col-md-6 col-lg-3">
            <label class="form-label">Fecha de publicación</label>
            <input class="form-control form-input" type="date" formControlName="publication" autocomplete="off"
                [class.is-invalid]="campoNoValido('publication')">
            <small class="text-danger" *ngIf="campoNoValido('publication')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-6 col-md-6 col-lg-3">
            <label class="form-label">Última actualización</label>
            <input class="form-control form-input" type="date" formControlName="lastUpdated" autocomplete="off"
                [class.is-invalid]="campoNoValido('lastUpdated')">
            <small class="text-danger" *ngIf="campoNoValido('lastUpdated')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-6 col-md-6 col-lg-3">
            <label class="form-label">Cuadrante</label>
            <select class="form-select form-input" formControlName="idquadrant">
                <option disabled selected [ngValue]="null">Cuadrante</option>
                <option *ngFor="let q of quadrants" value="{{q.id}}">
                    {{q.shorttitle}}
                </option>
            </select>
        </div>

        <div class="textOnInput col-6 col-md-6 col-lg-3">
            <label class="form-label">Periodo</label>
            <select class="form-select form-input" formControlName="idperiod">
                <option disabled selected [ngValue]="null">Periodo</option>
                <option *ngFor="let p of periods" value="{{p.id}}">
                    {{p.shorttitle}}
                </option>
            </select>
        </div>

        <div class="textOnInput col-md-3">
            <label class="form-label">Escala</label>
            <select class="form-select form-input" formControlName="scale">
                <option disabled selected [ngValue]="null">Escala</option>
                <option [ngValue]="'Global'">Global</option>
                <option [ngValue]="'Nacional'">Nacional</option>
            </select>
        </div>

        <div class="textOnInput col-md-9">
            <label class="form-label">Drivers</label>
            <input class="form-control form-input" type="text" formControlName="drivers" autocomplete="off">
        </div>

        <div class="textOnInput col-12">
            <label class="form-label">Supuestos de evolución</label>
            <textarea class="form-control" formControlName="suppositions" autocomplete="off" rows="3"></textarea>
        </div>

        <div class="textOnInput col-12">
            <label class="form-label">Actores involucrados</label>
            <textarea class="form-control" formControlName="actors" autocomplete="off" rows="3"></textarea>
        </div>

        <div class="textOnInput col-12">
            <label class="form-label">Riesgos vinculados</label>
            <div class="label-container">
                <div class="textOnInput col-12 col-md-6 mb-2">
                    <label class="form-label">Lista de riesgos</label>
                    <select class="form-select form-input" formControlName="selectedRisk" (change)="addRisk()">
                        <option disabled selected value="">Riesgos</option>
                        <option *ngFor="let r of risks" [ngValue]="r">{{r.shorttitle}} ({{r.code}})</option>
                    </select>
                </div>

                <div class="col-12">
                    <div class="row px-3">
                        <ng-container formArrayName="selectedRisks">
                            <div class="btn-related mt-2"
                                *ngFor="let riskFormGroup of selectedRisksControls.controls; index as i">
                                {{ riskFormGroup.value.shorttitle}}
                                <button class="btn-cross" type="button" (click)="triggerDeleteRiskConfirmation(i)">
                                    <i class="fa fa-times"></i>
                                </button>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <div *ngIf="showDeleteConfirmationRisk" class="confirmation-dialog">
                    <div>¿Estás seguro que quieres eliminar este elemento?</div>
                    <button (click)="confirmDeleteRisk()">Sí</button>
                    <button (click)="cancelDeleteRisk()">No</button>
                </div>
                <div class="textOnInput col-12">
                    <label class="form-label" for="inputText">Otros riesgos vinculados</label>
                    <textarea class="form-control" formControlName="otherRisksRelated" autocomplete="off"
                        rows="2"></textarea>
                </div>
            </div>
        </div>

        <div class="textOnInput col-12">
            <label class="form-label">Oportunidades vinculadas</label>
            <div class="label-container">
                <div class="textOnInput col-12 col-md-6 mb-2">
                    <label class="form-label">Lista de oportunidades</label>
                    <select class="form-select input-select" formControlName="selectedOpp" (change)="addOpp()">
                        <option disabled selected value="">Oportunidades</option>
                        <option *ngFor="let o of opportunities" [ngValue]="o">{{o.shorttitle}} ({{o.code}})</option>
                    </select>
                </div>

                <div class="col-12">
                    <div class="row px-3">
                        <ng-container formArrayName="selectedOpps">
                            <div class="btn-related mt-2"
                                *ngFor="let oppFormGroup of selectedOppsControls.controls; index as i">
                                {{oppFormGroup.value.shorttitle}}
                                <button class="btn-cross" type="button" (click)="triggerDeleteOppConfirmation(i)">
                                    <i class="fa fa-times"></i>
                                </button>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <div *ngIf="showDeleteConfirmationOpp" class="confirmation-dialog">
                    <div>¿Estás seguro que quieres eliminar este elemento?</div>
                    <button (click)="confirmDeleteOpp()">Sí</button>
                    <button (click)="cancelDeleteOpp()">No</button>
                </div>
                <div class="textOnInput col-12">
                    <label class="form-label" for="inputText">Otras oportunidades vinculadas</label>
                    <textarea class="form-control" formControlName="otherOppsRelated" autocomplete="off"
                        rows="2"></textarea>
                </div>
            </div>
        </div>

        <div class="textOnInput col-12">
            <label class="form-label">Tags</label>
            <input class="form-control form-input" type="text" formControlName="tags" autocomplete="off">
        </div>

        <div class="textOnInput col-12">
            <label class="form-label">Imagen</label>
            <div class="label-container ">
                <div class="row">
                    <div class="col-md-9">
                        <div class="input-group">
                            <div class="input-group-append">
                                <button class="btn btn-outline-primary custom-rounded-button" type="button"
                                    (click)="fileInput.click()">
                                    Cargar imagen
                                </button>
                            </div>
                            <input type="text" disabled class="form-control" placeholder="Imagen" formControlName="img">
                        </div>
                        <input #fileInput class="form-file" type="file" id="input-file" (change)="onFileChange($event)"
                            accept="image/png, .jpg, .webp" style="display: none;">
                    </div>
                    <div class="col-md-3">
                        <ng-container *ngIf="formT3.get('img').value != null">
                            <ng-container *ngIf="isUploadDir">
                                <img class="img-fluid" src="{{URL}}{{formT3.get('img').value}}" alt=""
                                    style="height: 120px; width:100px">
                            </ng-container>
                            <ng-container *ngIf="!isUploadDir">
                                <img src="{{formT3.get('img').value}}" alt="No se ha cargado una imagen"
                                    style="height: 50px;">
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
        <!--
        <div class="textOnInput col-12">
            <label class="form-label">Archivo en PDF</label>
            <input class="form-control form-input" disabled type="text" formControlName="urlfile" autocomplete="off">
        </div>
        -->
        <div class="textOnInput col-6 col-md-3">
            <label class="form-label">Ángulo</label>
            <input class="form-control form-input" type="number" formControlName="angle" autocomplete="off">
        </div>

        <div class="textOnInput col-6 col-md-3">
            <label class="form-label">Eje X</label>
            <input class="form-control form-input" type="number" formControlName="x" autocomplete="off">
        </div>

        <div class="textOnInput col-6 col-md-3">
            <label class="form-label">Eje Y</label>
            <input class="form-control form-input" type="number" formControlName="y" autocomplete="off">
        </div>

        <div class="textOnInput col-6 col-md-3">
            <label class="form-label">Márgen X</label>
            <input class="form-control form-input" type="number" formControlName="marginx" autocomplete="off">
        </div>

        <div class="textOnInput col-6 col-md-3">
            <label class="form-label">Márgen Y</label>
            <input class="form-control form-input" type="number" formControlName="marginy" autocomplete="off">
        </div>

        <div class="textOnInput col-6 col-md-3">
            <label class="form-label">Márgen texto X</label>
            <input class="form-control form-input" type="number" formControlName="margintx" autocomplete="off">
        </div>

        <div class="textOnInput col-6 col-md-3">
            <label class="form-label">Márgen texto Y</label>
            <input class="form-control form-input" type="number" formControlName="marginty" autocomplete="off">
        </div>

    <!--     <div class="textOnInput col-12">
            <label class="form-label">Visible/oculto</label>
            <div class="label-container align-switch">
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="switch1" formControlName="status">
                </div>
            </div>
        </div> -->

    </div>

    <div class="row">
        <div class="col-12">
            <div class="d-flex justify-content-start">
                <div class="me-2">
                    <button type="button" class="btn btn-outline-secondary btn-block"
                        [routerLink]="['/adm/evento/list']">
                        Cancelar
                    </button>
                </div>
                <div *ngIf="!t3 || (t3 && t3['isBlocked'] === false)">
                    <button type="submit" class="btn btn-outline-primary">Guardar</button>
                </div>
            </div>
        </div>
    </div>

</form>